export enum RESPONSE_CODE{
    CADUCADO = 1,
    MAX = 2,
    USER_NON_EXISTS = 3,
    USER_EXISTS = 4,
    INCORRECT_SMS = 5
}